import axios from 'axios';

// Get API key from environment or use a proxy for security
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';
const SVIX_API_KEY = process.env.REACT_APP_SVIX_API_KEY;
const SVIX_APP_ID = process.env.REACT_APP_SVIX_APP_ID;
const SVIX_API_URL = process.env.REACT_APP_SVIX_API_URL || 'https://api.svix.com';

// Create an axios instance with Svix auth
const svixApi = axios.create({
  baseURL: SVIX_API_URL,
  headers: {
    'Authorization': `Bearer ${SVIX_API_KEY}`,
    'Content-Type': 'application/json'
  }
});

// Endpoint APIs
export const fetchEndpoints = async () => {
  try {
    const response = await svixApi.get(`/api/v1/app/${SVIX_APP_ID}/endpoint`);
    return response.data.data || [];
  } catch (error) {
    console.error('Error fetching endpoints:', error);
    throw new Error(error.response?.data?.message || 'Failed to fetch endpoints');
  }
};

export const createEndpoint = async (data) => {
  try {
    const response = await svixApi.post(`/api/v1/app/${SVIX_APP_ID}/endpoint`, data);
    return response.data;
  } catch (error) {
    console.error('Error creating endpoint:', error);
    throw new Error(error.response?.data?.message || 'Failed to create endpoint');
  }
};

export const deleteEndpoint = async (id) => {
  try {
    await svixApi.delete(`/api/v1/app/${SVIX_APP_ID}/endpoint/${id}`);
    return true;
  } catch (error) {
    console.error('Error deleting endpoint:', error);
    throw new Error(error.response?.data?.message || 'Failed to delete endpoint');
  }
};

// Message APIs
export const fetchMessages = async (limit = 20, iterator = null, eventType = null) => {
  try {
    const params = new URLSearchParams();
    
    params.append('limit', String(limit));
    
    if (iterator) {
      params.append('iterator', iterator);
    }
    
    if (eventType) {
      params.append('eventType', eventType);
    }
    
    const response = await svixApi.get(`/api/v1/app/${SVIX_APP_ID}/msg?${params.toString()}`);
    return {
      messages: response.data.data || [],
      iterator: response.data.iterator || null,
    };
  } catch (error) {
    console.error('Error fetching messages:', error);
    throw new Error(error.response?.data?.message || 'Failed to fetch messages');
  }
};

export const fetchMessageDetails = async (messageId) => {
  try {
    const response = await svixApi.get(`/api/v1/app/${SVIX_APP_ID}/msg/${messageId}`);
    return response.data; // Return the full message object
  } catch (error) {
    console.error('Error fetching message details:', error);
    throw new Error(error.response?.data?.message || 'Failed to fetch message details');
  }
};

export const fetchMessageAttempts = async (messageId) => {
  try {
    const response = await svixApi.get(`/api/v1/app/${SVIX_APP_ID}/msg/${messageId}/attempt`);
    return response.data.data || [];
  } catch (error) {
    console.error('Error fetching message attempts:', error);
    throw new Error(error.response?.data?.message || 'Failed to fetch message attempts');
  }
};